// // import React, { useEffect, useState, useRef } from 'react';
// // import { useApp } from '../../contexts/AppContext';
// // import { auditAPI } from '../../services/api';
// // import '../../BrandPulse.css';

// // const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

// // const TechnicalSEOPage = () => {
// //   const { lastAuditInfo } = useApp();
// //   const [data, setData] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState('');
// //   const [refreshing, setRefreshing] = useState(false);
// //   const initialLoadDone = useRef(false);

// //   const fetchTechnicalSEOData = async (forceRefresh = false) => {
// //     try {
// //       const stored = localStorage.getItem('auditFormData');
// //       if (!stored) throw new Error('No audit data found.');
// //       const formData = JSON.parse(stored);
// //       const { websiteUrl } = formData;
// //       if (!websiteUrl) throw new Error('No website URL found.');

// //       const cacheKey = `technicalSEO_${websiteUrl}`;
// //       const cached = localStorage.getItem(cacheKey);
// //       const now = Date.now();

// //       if (!forceRefresh && cached) {
// //         const { timestamp, data: cachedData } = JSON.parse(cached);
// //         if (now - timestamp < CACHE_TTL) {
// //           setData(cachedData);
// //           setLoading(false);
// //           return;
// //         }
// //       }

// //       const response = await auditAPI.technicalseo({ domain: websiteUrl });
// //       const result = response?.data?.data || response?.data;
// //       if (!result) throw new Error('Invalid API response');
// //       console.log("Techincle response",JSON.stringify(result))
// //       // Map API response to our UI data structure
// //       const mappedData = {
// //         pages_indexed: result.summary_card?.pages_indexed?.value ?? 0,
// //         schema_count: result.summary_card?.schema_markup?.count ?? 0,
// //         broken_links: result.summary_card?.broken_links?.count ?? 0,
// //         alt_coverage: result.summary_card?.image_alt_coverage?.coverage ?? 0,
// //         ssl_status: result.ssl_status ?? { status: 'Secure', details: 'Certificate valid · Expires Jan 2027' },
// //         robots_txt: result.robots_txt ?? { status: 'Present', url: `${websiteUrl}/robots.txt` },
// //         sitemap: result.sitemap ?? { status: 'Present', url: `${websiteUrl}/sitemap.xml` },
// //         google_analytics: result.google_analytics ?? { detected: true, id: 'G-XXXXXXXXXX' },
// //         google_tag_manager: result.google_tag_manager ?? { detected: true, id: 'GTM-XXXXXXX' },
// //         meta_pixel: result.meta_pixel ?? { detected: false },
// //         mobile_usability: result.mobile_usability ?? { status: 'Pass', details: 'Lighthouse mobile audit — no issues found' },
// //         core_web_vitals: result.core_web_vitals ?? { status: 'Partial Pass', details: 'LCP fails — FCP needs improvement' },
// //         schema_markup_types: result.schema_markup_types ?? { found: ['LocalBusiness', 'WebSite'], missing: ['FAQ', 'Service', 'BreadcrumbList', 'Product'], count: 2 },
// //         meta_title_issues: result.meta_title_issues ?? { count: 8, details: '8 pages with missing or duplicate title tags' },
// //         canonical_tags: result.canonical_tags ?? { status: 'Present', details: 'All key pages have canonical tags set' },
// //         broken_links_details: result.broken_links_details ?? { count: 4, internal: 3, external: 1 },
// //         insight: result.insight || 'Meta Pixel is not installed — you cannot run retargeting ads on Instagram or Facebook. Install via GTM in 30 minutes. Adding FAQ, Service and BreadcrumbList schema unlocks Google rich results. Fix 8 meta title issues to improve CTR by 15–20%.',
// //       };

// //       localStorage.setItem(cacheKey, JSON.stringify({ timestamp: now, data: mappedData }));
// //       setData(mappedData);
// //     } catch (err) {
// //       console.error(err);
// //       setError(err.message || 'Failed to load technical SEO data');
// //     } finally {
// //       setLoading(false);
// //       setRefreshing(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (!initialLoadDone.current) {
// //       initialLoadDone.current = true;
// //       fetchTechnicalSEOData();
// //     }
// //   }, []);

// //   useEffect(() => {
// //     if (initialLoadDone.current) {
// //       fetchTechnicalSEOData(true);
// //     }
// //   }, [lastAuditInfo]);

// //   const handleRefresh = () => {
// //     setRefreshing(true);
// //     fetchTechnicalSEOData(true);
// //   };

// //   if (loading) return <div className="pad">Loading...</div>;
// //   if (error) return <div className="pad error">{error}</div>;
// //   if (!data) return <div className="pad">No data</div>;

// //   return (
// //     <div className="pad">
// //       <div className="sec-hd">
// //         <div className="sec-ey">Brand Audit</div>
// //         <div className="sec-ti">Technical SEO</div>
// //         <div className="sec-ds">Full technical health check — Lighthouse CLI + in-house HTML parsing</div>
// //         <button onClick={handleRefresh} disabled={refreshing} className="refresh-btn">
// //           {refreshing ? 'Refreshing...' : 'Refresh'}
// //         </button>
// //       </div>
// //       <div className="g4">
// //         <div className="stat">
// //           <div className="stat-bar" style={{ background: '#059669' }}></div>
// //           <div className="stat-lbl">Pages Indexed</div>
// //           <div className="stat-val" style={{ color: '#059669' }}>{data.pages_indexed}</div>
// //           <div className="stat-sub">SerpApi site: query</div>
// //         </div>
// //         <div className="stat">
// //           <div className="stat-bar" style={{ background: '#dc2626' }}></div>
// //           <div className="stat-lbl">Schema Types</div>
// //           <div className="stat-val" style={{ color: '#dc2626' }}>{data.schema_count}</div>
// //           <div className="stat-sub">of 7 recommended</div>
// //           <div className="stat-badge bdn">Low</div>
// //         </div>
// //         <div className="stat">
// //           <div className="stat-bar" style={{ background: '#d97706' }}></div>
// //           <div className="stat-lbl">Broken Links</div>
// //           <div className="stat-val" style={{ color: '#d97706' }}>{data.broken_links}</div>
// //           <div className="stat-sub">found on website</div>
// //           <div className="stat-badge bok">Fix Soon</div>
// //         </div>
// //         <div className="stat">
// //           <div className="stat-bar" style={{ background: '#059669' }}></div>
// //           <div className="stat-lbl">Alt Text Coverage</div>
// //           <div className="stat-val" style={{ color: '#059669' }}>{data.alt_coverage}%</div>
// //           <div className="stat-sub">images with alt text</div>
// //           <div className="stat-badge bok">Improve</div>
// //         </div>
// //       </div>
// //       <div className="card">
// //         <div className="card-hd"><div><div className="card-ti">Technical Checks — All In-house</div><div className="card-ds">HTML parsing + Lighthouse CLI + HTTP checks</div></div></div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">HTTPS / SSL</div>
// //             <div className="tech-check-sub">{data.ssl_status.details || data.ssl_status}</div>
// //           </div>
// //           <span className={data.ssl_status.status === 'Secure' ? 'tc-pass' : 'tc-fail'}>{data.ssl_status.status}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">robots.txt</div>
// //             <div className="tech-check-sub">{data.robots_txt.url || data.robots_txt.details} · 200 OK</div>
// //           </div>
// //           <span className={data.robots_txt.status === 'Present' ? 'tc-pass' : 'tc-fail'}>{data.robots_txt.status}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">sitemap.xml</div>
// //             <div className="tech-check-sub">{data.sitemap.url || data.sitemap.details} · 200 OK</div>
// //           </div>
// //           <span className={data.sitemap.status === 'Present' ? 'tc-pass' : 'tc-fail'}>{data.sitemap.status}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Google Analytics (GA4)</div>
// //             <div className="tech-check-sub">gtag.js detected — {data.google_analytics.id || 'G-XXXXXXXXXX'}</div>
// //           </div>
// //           <span className={data.google_analytics.detected ? 'tc-pass' : 'tc-fail'}>Detected</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Google Tag Manager</div>
// //             <div className="tech-check-sub">GTM container detected — {data.google_tag_manager.id || 'GTM-XXXXXXX'}</div>
// //           </div>
// //           <span className={data.google_tag_manager.detected ? 'tc-pass' : 'tc-fail'}>Detected</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Meta Pixel</div>
// //             <div className="tech-check-sub">{data.meta_pixel.detected ? 'fbq() found on page' : 'No fbq() or Meta script found on page'}</div>
// //           </div>
// //           <span className={data.meta_pixel.detected ? 'tc-pass' : 'tc-fail'}>{data.meta_pixel.detected ? 'Detected' : 'Not Detected'}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Mobile Usability</div>
// //             <div className="tech-check-sub">{data.mobile_usability.details}</div>
// //           </div>
// //           <span className={data.mobile_usability.status === 'Pass' ? 'tc-pass' : 'tc-fail'}>{data.mobile_usability.status}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Core Web Vitals</div>
// //             <div className="tech-check-sub">{data.core_web_vitals.details}</div>
// //           </div>
// //           <span className={data.core_web_vitals.status === 'Pass' ? 'tc-pass' : data.core_web_vitals.status === 'Partial Pass' ? 'tc-warn' : 'tc-fail'}>{data.core_web_vitals.status}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Schema Markup Types</div>
// //             <div className="tech-check-sub">Found: {data.schema_markup_types.found.join(', ')} · Missing: {data.schema_markup_types.missing.join(', ')}</div>
// //           </div>
// //           <span className="tc-warn">{data.schema_markup_types.count} of {data.schema_markup_types.found.length + data.schema_markup_types.missing.length}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Meta Title Issues</div>
// //             <div className="tech-check-sub">{data.meta_title_issues.details}</div>
// //           </div>
// //           <span className="tc-warn">{data.meta_title_issues.count} Issues</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Image Alt Coverage</div>
// //             <div className="tech-check-sub">{data.alt_coverage}% of images have alt text</div>
// //           </div>
// //           <span className="tc-warn">{data.alt_coverage}%</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Canonical Tags</div>
// //             <div className="tech-check-sub">{data.canonical_tags.details}</div>
// //           </div>
// //           <span className={data.canonical_tags.status === 'Present' ? 'tc-pass' : 'tc-fail'}>{data.canonical_tags.status}</span>
// //         </div>
// //         <div className="tech-check">
// //           <div>
// //             <div className="tech-check-name">Broken Links</div>
// //             <div className="tech-check-sub">{data.broken_links_details.count} broken links found — {data.broken_links_details.internal} internal, {data.broken_links_details.external} external</div>
// //           </div>
// //           <span className="tc-warn">{data.broken_links_details.count} Found</span>
// //         </div>
// //         <div className="insight" style={{ marginTop: '16px' }}>
// //           <div className="ins-lbl">✦ AI Insight</div>
// //           <div className="ins-txt">{data.insight}</div>
// //           <div className="ins-tags"><span className="itag ih">⚡ High Priority</span><span className="itag im">Meta Pixel + Schema</span></div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default TechnicalSEOPage;
// import React, { useEffect, useState, useRef } from 'react';
// import { useApp } from '../../contexts/AppContext';
// import { auditAPI } from '../../services/api';
// import '../../BrandPulse.css';
// import { computeOverallScore } from '../../utils/scoreUtils';
// const CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

// const TechnicalSEOPage = () => {
//   const {setLastAuditInfo, lastAuditInfo } = useApp()
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [refreshing, setRefreshing] = useState(false);
//   const initialLoadDone = useRef(false);
//   const istechFetching = useRef(false); 

 

  
//   const fetchTechnicalSEOData = async (forceRefresh = false) => {
//     if (!forceRefresh && istechFetching.current) {
//       console.log('[TechSEO] Already fetching, skipping');
//       return;
//     }
//     istechFetching.current = true;

//   try {
//     const stored = localStorage.getItem('auditFormData');
//     if (!stored) throw new Error('No audit data found. Please complete the audit form first.');
//     const formData = JSON.parse(stored);
//     const { websiteUrl } = formData;
//     if (!websiteUrl) throw new Error('No website URL found in audit data.');

//     const domain = websiteUrl.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0];
//     const cacheKey = `technicalSEO_${domain}`;
//     const now = Date.now();

//     // ✅ Step 1 — clear cache FIRST before any reads
//     if (forceRefresh) {
//       localStorage.removeItem(cacheKey);
//     }    

//     // ✅ Step 2 — NOW read cache (will be null if we just cleared it)
//     const cached = localStorage.getItem(cacheKey);
//     if (cached) {
//       const { timestamp, data: cachedData } = JSON.parse(cached);
//       if (now - timestamp < CACHE_TTL) {
//         setData(cachedData);
//         updateGlobalContext(cachedData);
//         setLoading(false);
//         setRefreshing(false);
//         return;
//       }
//     }

//     // Step 3 — fetch fresh from API
//     const result = await auditAPI.technicalseo({
//       domain: websiteUrl,
//       force_refresh: forceRefresh,
//     });

//     if (!result) throw new Error('No data received from server');

//     // ✅ result IS the final data — just unwrap one level
//     const response = result?.data || result;
//     console.log("technology response",JSON.stringify(response))
//     if (!response) throw new Error('Invalid API response structure');

//     const summary = response.summary_card || {};
//     const metrics = response.metrics || {};

//     const mappedData = {
//       pages_indexed: summary.pages_indexed?.value ?? 0,
//       schema_count: summary.schema_markup?.count ?? 0,
//       broken_links: summary.broken_links?.count ?? 0,
//       alt_coverage: summary.image_alt_coverage?.coverage ?? 0,
//       ssl_status: {
//         status: summary.https_ssl?.status === 'Secure' ? 'Secure' :
//                 summary.https_ssl?.status === 'Expiring Soon' ? 'Expiring Soon' : 'Unknown',
//         details: summary.https_ssl?.expires_in_days ?
//                  `Certificate expires in ${summary.https_ssl.expires_in_days} days` :
//                  'Certificate valid',
//       },
//       robots_txt: {
//         status: metrics.robots_txt?.status === 'present' ? 'Present' : 'Missing',
//         url: `${websiteUrl}/robots.txt`,
//         details: metrics.robots_txt?.analysis?.sitemap_references?.length ?
//                  'Sitemap referenced' : 'No sitemap reference',
//       },
//       sitemap: {
//         status: summary.sitemap?.status === 'Present' ? 'Present' : 'Missing',
//         url: `${websiteUrl}/sitemap.xml`,
//         details: summary.sitemap?.url_count ? `${summary.sitemap.url_count} URLs` : '',
//       },
//       google_analytics: {
//         detected: metrics.google_analytics?.detected ?? false,
//         id: metrics.google_analytics?.measurement_id || 'G-XXXXXXXXXX',
//       },
//       google_tag_manager: {
//         detected: metrics.google_tag_manager?.detected ?? false,
//         id: metrics.google_tag_manager?.container_id || 'GTM-XXXXXXX',
//       },
//       meta_pixel: {
//         detected: metrics.meta_pixel?.detected ?? false,
//       },
//       mobile_usability: {
//         status: summary.mobile_usability?.status === 'Pass' ? 'Pass' : 'Issues Found',
//         details: `Lighthouse mobile audit — ${summary.mobile_usability?.status === 'Pass' ? 'no issues found' : 'issues detected'}`,
//       },
//       core_web_vitals: {
//         status: summary.core_web_vitals?.status === 'Pass' ? 'Pass' :
//                 summary.core_web_vitals?.status === 'Fail' ? 'Fail' : 'Partial Pass',
//         details: summary.core_web_vitals?.lcp ?
//                  `LCP ${summary.core_web_vitals.lcp.displayValue} — needs improvement` :
//                  'Data not available',
//       },
//       schema_markup_types: {
//         found:   summary.schema_markup?.types   || [],
//         missing: summary.schema_markup?.missing || [],
//         count:   summary.schema_markup?.count   ?? 0,
//       },
//       meta_title_issues: {
//         count:   summary.meta_title_issues?.count   ?? 0,
//         details: summary.meta_title_issues?.display || 'No issues',
//       },
//       canonical_tags: {
//         status:  metrics.canonical_issues?.status === 'good' ? 'Present' : 'Needs Improvement',
//         details: metrics.canonical_issues?.has_canonical ?
//                  'All key pages have canonical tags set' :
//                  'Missing canonical tags on some pages',
//       },
//       broken_links_details: {
//         count:    summary.broken_links?.count ?? 0,
//         internal: 0,
//         external: 0,
//       },
//       insight: response.ai_insight?.insight || 'No AI insight available.',
//     };
//     console.log("technology SEO Response",JSON.stringify(mappedData))
//     // ✅ Step 4 — write fresh data to cache
//     localStorage.setItem(cacheKey, JSON.stringify({ timestamp: now, data: mappedData }));
//     setData(mappedData);
//     updateGlobalContext(mappedData);
//     //setError('');

//   } catch (err) {
//     console.error('Fetch error:', err);
//     let errorMessage = 'Failed to load technical SEO data. ';
//     if (err.message === 'Network Error' || err.code === 'ERR_NETWORK') {
//       errorMessage += 'Please check if the backend server is running.';
//     } else if (err.response?.status === 500) {
//       errorMessage += 'Server error. Please try again later.';
//     } else if (err.response?.status === 422) {
//       errorMessage += 'Invalid request format.';
//     } else if (err.message) {
//       errorMessage += err.message;
//     }
//     setError(errorMessage);
//   } finally {
//     istechFetching.current = false;
//     setLoading(false);
//     setRefreshing(false);
//   }
// };

// const updateGlobalContext = (metrics) => {
//   // ✅ Read fresh from localStorage — avoids stale closure re-render loop
//   let current = {};
//   try {
//     const saved = localStorage.getItem('lastAuditInfo');
//     if (saved) current = JSON.parse(saved);
//   } catch (_) {}

//   // ✅ Skip recomputation if overall score already exists
//   if (current.overallScore !== undefined && current.overallScore !== null) {
//     return;
//   }

//   const prev = current?.scoreInputs || {};

//   const scoreInputs = {
//     ...prev,
//     // ✅ Fixed: 'Present' capital P matches your mappedData
//     hasSitemap:     metrics.sitemap?.status === 'Present',
//     // ✅ Fixed: 'Present' capital P matches your mappedData robots_txt mapping
//     hasRobots:      metrics.robots_txt?.status === 'Present',
//     hasBrokenLinks: (metrics.broken_links ?? 0) > 0,
//     hasSSL:         metrics.ssl_status?.status === 'Secure',
//     // ✅ Fixed: missing is an array not a string, check correctly
//     hasFAQSchema:   (metrics.schema_markup_types?.found || []).length > 0,
//     hasCitations:   (metrics.schema_markup_types?.missing || []).length === 0,
//   };

//   console.log('[TechSEO] scoreInputs:', scoreInputs);

//   setLastAuditInfo({
//     ...current,          // ✅ spread current from localStorage, not stale closure
//     scoreInputs,
//     overallScore: computeOverallScore(scoreInputs),
//   });
// };

//    useEffect(() => {
//     if (!initialLoadDone.current) {
//         initialLoadDone.current = true;
//       fetchTechnicalSEOData();
//     }
//   }, []);

//   // useEffect(() => {
//   //   if (initialLoadDone.current && lastAuditInfo) {
//   //     console.log('lastAuditInfo changed, refreshing data');
//   //     fetchTechnicalSEOData(true);
//   //   }
//   // }, [lastAuditInfo]);


//   const handleRefresh = async () => {
//     console.log('Manual refresh triggered');
//     setRefreshing(true);
//     setError(''); // Clear errors before refresh
//     await fetchTechnicalSEOData(true);
//   };

//   if (loading) return (
//       <div style={{ textAlign: 'center', padding: '40px' }}>
//         <div>⏳ Running audit... this may take 2–3 minutes</div>
//         <div style={{ fontSize: '12px', color: '#888', marginTop: '8px' }}>
//           Please wait, do not refresh the page
//         </div>
//       </div>
//     );

//     if (error) return <div className="pad error">{error}</div>;
//     if (!data)  return <div className="pad">No data available.</div>;


//   return (
//     <div id="report-content" className="report-container">
//     <div className="pad">
//       <div className="sec-hd">
//         <div className="sec-ey">Brand Audit</div>
//         <div className="sec-ti">Technical SEO</div>
//         <div className="sec-ds">Full technical health check </div>
//         {/* — Lighthouse CLI + in-house HTML parsing */}
//         <button onClick={handleRefresh} disabled={refreshing} className="refresh-btn">
//           {refreshing ? 'Refreshing...' : '↻ Refresh'}
//         </button>
//       </div>
//       <div className="g4">
//         <div className="stat">
//           <div className="stat-bar" style={{ background: '#059669' }}></div>
//           <div className="stat-lbl">Pages Indexed</div>
//           <div className="stat-val" style={{ color: '#059669' }}>{data.pages_indexed}</div>
//           <div className="stat-sub">SerpApi site: query</div>
//         </div>
//         <div className="stat">
//           <div className="stat-bar" style={{ background: '#dc2626' }}></div>
//           <div className="stat-lbl">Schema Types</div>
//           <div className="stat-val" style={{ color: '#dc2626' }}>{data.schema_count}</div>
//           <div className="stat-sub">of 7 recommended</div>
//           <div className="stat-badge bdn">Low</div>
//         </div>
//         <div className="stat">
//           <div className="stat-bar" style={{ background: '#d97706' }}></div>
//           <div className="stat-lbl">Broken Links</div>
//           <div className="stat-val" style={{ color: '#d97706' }}>{data.broken_links}</div>
//           <div className="stat-sub">found on website</div>
//           <div className="stat-badge bok">Fix Soon</div>
//         </div>
//         <div className="stat">
//           <div className="stat-bar" style={{ background: '#059669' }}></div>
//           <div className="stat-lbl">Alt Text Coverage</div>
//           <div className="stat-val" style={{ color: '#059669' }}>{data.alt_coverage}%</div>
//           <div className="stat-sub">images with alt text</div>
//           <div className="stat-badge bok">Improve</div>
//         </div>
//       </div>
//       <div className="card">
//         <div className="card-hd"><div><div className="card-ti">Technical Checks — All In-house</div><div className="card-ds">HTML parsing + Lighthouse CLI + HTTP checks</div></div></div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">HTTPS / SSL</div>
//             <div className="tech-check-sub">{data.ssl_status.details}</div>
//           </div>
//           <span className={data.ssl_status.status === 'Secure' ? 'tc-pass' : data.ssl_status.status === 'Expiring Soon' ? 'tc-warn' : 'tc-fail'}>{data.ssl_status.status}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">robots.txt</div>
//             <div className="tech-check-sub">{data.robots_txt.url} · 200 OK</div>
//           </div>
//           <span className={data.robots_txt.status === 'Present' ? 'tc-pass' : 'tc-fail'}>{data.robots_txt.status}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">sitemap.xml</div>
//             <div className="tech-check-sub">{data.sitemap.url} · 200 OK</div>
//           </div>
//           <span className={data.sitemap.status === 'Present' ? 'tc-pass' : 'tc-fail'}>{data.sitemap.status}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Google Analytics (GA4)</div>
//             <div className="tech-check-sub">gtag.js detected — {data.google_analytics.id}</div>
//           </div>
//           <span className={data.google_analytics.detected ? 'tc-pass' : 'tc-fail'}>Detected</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Google Tag Manager</div>
//             <div className="tech-check-sub">GTM container detected — {data.google_tag_manager.id}</div>
//           </div>
//           <span className={data.google_tag_manager.detected ? 'tc-pass' : 'tc-fail'}>Detected</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Meta Pixel</div>
//             <div className="tech-check-sub">{data.meta_pixel.detected ? 'fbq() found on page' : 'No fbq() or Meta script found on page'}</div>
//           </div>
//           <span className={data.meta_pixel.detected ? 'tc-pass' : 'tc-fail'}>{data.meta_pixel.detected ? 'Detected' : 'Not Detected'}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Mobile Usability</div>
//             <div className="tech-check-sub">{data.mobile_usability.details}</div>
//           </div>
//           <span className={data.mobile_usability.status === 'Pass' ? 'tc-pass' : 'tc-fail'}>{data.mobile_usability.status}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Core Web Vitals</div>
//             <div className="tech-check-sub">{data.core_web_vitals.details}</div>
//           </div>
//           <span className={data.core_web_vitals.status === 'Pass' ? 'tc-pass' : data.core_web_vitals.status === 'Partial Pass' ? 'tc-warn' : 'tc-fail'}>{data.core_web_vitals.status}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Schema Markup Types</div>
//             <div className="tech-check-sub">Found: {data.schema_markup_types.found.join(', ') || 'None'} · Missing: {data.schema_markup_types.missing.join(', ')}</div>
//           </div>
//           <span className="tc-warn">{data.schema_markup_types.count} of {data.schema_markup_types.found.length + data.schema_markup_types.missing.length}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Meta Title Issues</div>
//             <div className="tech-check-sub">{data.meta_title_issues.details}</div>
//           </div>
//           <span className="tc-warn">{data.meta_title_issues.count} Issues</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Image Alt Coverage</div>
//             <div className="tech-check-sub">{data.alt_coverage}% of images have alt text</div>
//           </div>
//           <span className="tc-warn">{data.alt_coverage}%</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Canonical Tags</div>
//             <div className="tech-check-sub">{data.canonical_tags.details}</div>
//           </div>
//           <span className={data.canonical_tags.status === 'Present' ? 'tc-pass' : 'tc-fail'}>{data.canonical_tags.status}</span>
//         </div>
//         <div className="tech-check">
//           <div>
//             <div className="tech-check-name">Broken Links</div>
//             <div className="tech-check-sub">{data.broken_links_details.count} broken links found</div>
//           </div>
//           <span className="tc-warn">{data.broken_links_details.count} Found</span>
//         </div>
//         <div className="insight" style={{ marginTop: '16px' }}>
//           <div className="ins-lbl">✦ AI Insight</div>
//           <div className="ins-txt">{data.insight}</div>
//           <div className="ins-tags"><span className="itag ih">⚡ High Priority</span><span className="itag im">Meta Pixel + Schema</span></div>
//         </div>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default TechnicalSEOPage;

// src/components/BrandAudit/Step7_TechnicalSEO.jsx
// import React, { useState, useEffect } from 'react';

// const CACHE_TTL = 24 * 60 * 60 * 1000;

// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// const getTechData = (domain) => {
//   const cacheKey = `technicalSEO_${domain}`;
//   const cached = localStorage.getItem(cacheKey);
//   if (cached) {
//     const { timestamp, data } = JSON.parse(cached);
//     if (Date.now() - timestamp < CACHE_TTL) return data;
//   }
//   return null;
// };

// const TechnicalSEOPage = ({ websiteUrl, onContinue }) => {
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState(null);

//   const checkDataReady = () => {
//     const domain = cleanDomain(websiteUrl);
//     if (!domain) return false;
//     const techData = getTechData(domain);
//     if (techData) {
//       setData(techData);
//       setLoading(false);
//       return true;
//     }
//     return false;
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (checkDataReady()) clearInterval(interval);
//     }, 500);
//     return () => clearInterval(interval);
//   }, [websiteUrl]);

//   if (loading) {
//     return (
//       <div className="card" id="card-7">
//         <div className="eyebrow">Technical SEO</div>
//         <h2 className="ctitle">Website Technical Audit</h2>
//         <p className="cdesc">A deep technical check of your website — what's working, what's broken, and what needs attention.</p>
//         <div className="tseo-fetch show">
//           <div className="spinner" />
//           <span>Running technical audit on your website…</span>
//         </div>
//       </div>
//     );
//   }

//   if (!data) {
//     return (
//       <div className="card" id="card-7">
//         <div className="eyebrow">Technical SEO</div>
//         <h2 className="ctitle">Website Technical Audit</h2>
//         <p className="cdesc">No technical data available. Please try refreshing.</p>
//       </div>
//     );
//   }

//   // Helper to get badge class based on status
//   const getBadgeClass = (status) => {
//     if (status === 'Secure' || status === 'Present' || status === 'Pass' || status === 'Detected' || status === 'Active') return 'badge-pass';
//     if (status === 'Expiring Soon' || status === 'Partial Pass' || status === 'Issues Found') return 'badge-warn';
//     return 'badge-fail';
//   };

//   return (
//     <div className="card" id="card-7">
//       <div className="eyebrow">Technical SEO</div>
//       <h2 className="ctitle">Website Technical Audit</h2>
//       <p className="cdesc">A deep technical check of your website — what's working, what's broken, and what needs attention.</p>

//       {/* <div className="c6-dev">
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="#8B6DBF">
//           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
//         </svg>
//         <span><strong>Developer note:</strong> Pages Indexed → Google Search Console API. Broken Links → Screaming Frog / custom crawler. Alt Text → DOM scrape. Schema → JSON-LD parser. HTTPS/robots/sitemap → direct HTTP fetch. GA4/GTM/Meta Pixel → source scan. Mobile Usability → PageSpeed API. Canonical/Meta Titles → DOM parse.</span>
//       </div> */}

//       <div className="tseo-wrap show">
//         {/* Key Metrics */}
//         <div className="tseo-section">Key Metrics</div>
//         <div className="tseo-stats">
//           <div className="tstat">
//             <div className="tstat-top">
//               <span className="tstat-label">Pages Indexed</span>
//               <span className={`tstat-badge ${data.pages_indexed > 0 ? 'badge-pass' : 'badge-fail'}`}>
//                 {data.pages_indexed > 0 ? 'Good' : 'Low'}
//               </span>
//             </div>
//             <div className="tstat-val">{data.pages_indexed}</div>
//             <div className="tstat-sub">via Google Search Console</div>
//           </div>
//           <div className="tstat">
//             <div className="tstat-top">
//               <span className="tstat-label">Schema Types</span>
//               <span className={`tstat-badge ${data.schema_count >= 5 ? 'badge-pass' : data.schema_count >= 2 ? 'badge-warn' : 'badge-fail'}`}>
//                 {data.schema_count >= 5 ? 'Good' : data.schema_count >= 2 ? 'Partial' : 'Low'}
//               </span>
//             </div>
//             <div className="tstat-val">{data.schema_count}</div>
//             <div className="tstat-sub">of 7 recommended</div>
//           </div>
//           <div className="tstat">
//             <div className="tstat-top">
//               <span className="tstat-label">Broken Links</span>
//               <span className={`tstat-badge ${data.broken_links === 0 ? 'badge-pass' : data.broken_links <= 5 ? 'badge-warn' : 'badge-fail'}`}>
//                 {data.broken_links === 0 ? 'Clean' : data.broken_links <= 5 ? 'Fix Soon' : 'Critical'}
//               </span>
//             </div>
//             <div className="tstat-val">{data.broken_links}</div>
//             <div className="tstat-sub">found on website</div>
//           </div>
//           <div className="tstat">
//             <div className="tstat-top">
//               <span className="tstat-label">Alt Text Coverage</span>
//               <span className={`tstat-badge ${data.alt_coverage >= 80 ? 'badge-pass' : data.alt_coverage >= 50 ? 'badge-warn' : 'badge-fail'}`}>
//                 {data.alt_coverage >= 80 ? 'Good' : data.alt_coverage >= 50 ? 'Partial' : 'Poor'}
//               </span>
//             </div>
//             <div className="tstat-val">{data.alt_coverage}%</div>
//             <div className="tstat-sub">images with alt text</div>
//           </div>
//         </div>

//         {/* Technical Checks */}
//         <div className="tseo-section">Technical Checks</div>
//         <div className="tseo-checks">
//           {[
//             { name: 'HTTPS / SSL', desc: 'Secure connection status', status: data.ssl_status.status, badge: data.ssl_status.status, insight: data.ssl_status.details },
//             { name: 'robots.txt', desc: 'Search engine crawl instructions', status: data.robots_txt.status, badge: data.robots_txt.status, insight: `${data.robots_txt.url} — ${data.robots_txt.details}` },
//             { name: 'sitemap.xml', desc: 'Page discovery map for search engines', status: data.sitemap.status, badge: data.sitemap.status, insight: `${data.sitemap.url} — ${data.sitemap.details}` },
//             { name: 'Google Analytics GA4', desc: 'Website traffic tracking', status: data.google_analytics.detected ? 'Detected' : 'Not Detected', badge: data.google_analytics.detected ? 'Active' : 'Missing', insight: data.google_analytics.detected ? `Measurement ID: ${data.google_analytics.id}` : 'GA4 not found – install gtag.js' },
//             { name: 'Google Tag Manager', desc: 'Tag and tracking management', status: data.google_tag_manager.detected ? 'Detected' : 'Not Detected', badge: data.google_tag_manager.detected ? 'Active' : 'Missing', insight: data.google_tag_manager.detected ? `Container ID: ${data.google_tag_manager.id}` : 'GTM not found – install container snippet' },
//             { name: 'Meta Pixel', desc: 'Facebook/Instagram ad tracking', status: data.meta_pixel.detected ? 'Detected' : 'Not Detected', badge: data.meta_pixel.detected ? 'Active' : 'Missing', insight: data.meta_pixel.detected ? 'Meta Pixel installed' : 'Not installed – can’t retarget ads', critical: !data.meta_pixel.detected },
//             { name: 'Mobile Usability', desc: 'Google mobile-friendliness check', status: data.mobile_usability.status, badge: data.mobile_usability.status, insight: data.mobile_usability.details },
//             { name: 'Core Web Vitals', desc: 'Google page experience signals', status: data.core_web_vitals.status, badge: data.core_web_vitals.status, insight: data.core_web_vitals.details, critical: data.core_web_vitals.status !== 'Pass' },
//             { name: 'Schema Markup', desc: 'Structured data for rich search results', status: `${data.schema_markup_types.count} types`, badge: `${data.schema_markup_types.count} found`, insight: `Found: ${data.schema_markup_types.found.join(', ') || 'None'} · Missing: ${data.schema_markup_types.missing.join(', ')}` },
//             { name: 'Meta Title Issues', desc: 'Page title length and duplication check', status: `${data.meta_title_issues.count} issues`, badge: `${data.meta_title_issues.count} issues`, insight: data.meta_title_issues.details, critical: data.meta_title_issues.count > 0 },
//             { name: 'Image Alt Coverage', desc: 'Accessibility and image SEO', status: `${data.alt_coverage}%`, badge: `${data.alt_coverage}% covered`, insight: `${100 - data.alt_coverage}% of images missing alt text` },
//             { name: 'Canonical Tags', desc: 'Duplicate content prevention', status: data.canonical_tags.status, badge: data.canonical_tags.status, insight: data.canonical_tags.details },
//             { name: 'Broken Links', desc: 'Internal and external link health', status: `${data.broken_links_details.count} found`, badge: `${data.broken_links_details.count} found`, insight: `Internal: ${data.broken_links_details.internal}, External: ${data.broken_links_details.external}`, critical: data.broken_links_details.count > 0 },
//           ].map((check, idx) => {
//             const isBad = check.status === 'Missing' || check.status === 'Not Detected' || check.status === 'Issues Found' || check.status === 'Fail' || check.critical;
//             const isWarn = check.status === 'Expiring Soon' || check.status === 'Partial Pass' || check.status === 'Needs Improvement' || (check.status === 'Issues Found' && !isBad);
//             let badgeClass = 'badge-pass';
//             if (isBad) badgeClass = 'badge-fail';
//             else if (isWarn) badgeClass = 'badge-warn';
//             else badgeClass = 'badge-pass';

//             const iconClass = isBad ? 'icon-fail' : (isWarn ? 'icon-warn' : 'icon-pass');
//             const icon = isBad ? '❌' : (isWarn ? '⚠️' : '✅');
//             const insClass = isBad ? 'ins-fail' : (isWarn ? 'ins-warn' : 'ins-pass');

//             return (
//               <div key={idx} className={`tcheck-row ${isBad ? 'critical' : ''}`}>
//                 <div className="tcheck-top">
//                   <div className={`tcheck-icon ${iconClass}`}>{icon}</div>
//                   <div className="tcheck-info">
//                     <div className="tcheck-name">{check.name}</div>
//                     <div className="tcheck-desc">{check.desc}</div>
//                   </div>
//                   <span className={`tcheck-badge ${badgeClass}`}>{check.badge}</span>
//                 </div>
//                 <div className={`tcheck-insight ${insClass}`}>
//                   <svg viewBox="0 0 24 24" width="13" height="13">
//                     {isBad ? <path fill="#C0392B" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/> :
//                      isWarn ? <path fill="#C47D1A" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/> :
//                      <path fill="#0D9488" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>}
//                   </svg>
//                   <span>{check.insight}</span>
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Insight Box */}
//         <div className="insight-box">
//           <div className="insight-header">
//             <div className="insight-title">
//               <svg viewBox="0 0 24 24"><path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/></svg>
//               Technical SEO Insight
//             </div>
//             <button className="play-btn" onClick={() => {
//               const utterance = new SpeechSynthesisUtterance(data.insight.replace(/<[^>]*>/g, ''));
//               utterance.lang = 'en-IN';
//               speechSynthesis.speak(utterance);
//             }}>
//               <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
//               Play
//             </button>
//           </div>
//           <div className="insight-text">{data.insight}</div>
//         </div>
//       </div>

//       <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
//         Continue to GMB Map Ranking
//         <svg viewBox="0 0 24 24" fill="white"><path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/></svg>
//       </button>
//     </div>
//   );
// };

// src/components/BrandAudit/Step7_TechnicalSEO.jsx
import React, { useState, useEffect, useRef } from 'react';
import { GoogleGenerativeAI } from '@google/generative-ai';
import { auditAPI } from '../../services/api';

const CACHE_TTL = 24 * 60 * 60 * 1000;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

const getTechData = (domain) => {
  const cacheKey = `technicalSEO_${domain}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    const { timestamp, data } = JSON.parse(cached);
    if (Date.now() - timestamp < CACHE_TTL) return data;
  }
  return null;
};

// ─── Gemini API wrapper ───────────────────────────────────────────────────
const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
const callGemini = async (prompt) => {
  if (!GEMINI_API_KEY) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
  try {
    const model = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
    const result = await model.generateContent(prompt);
    const response = await result.response;
    return response.text();
  } catch (error) {
    console.error('Gemini SDK error:', error);
    throw new Error('Gemini API request failed');
  }
};

const INSIGHT_TTL = 24 * 60 * 60 * 1000;

const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight', autoGenerate = true }) => {
  const [aiText, setAiText]       = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError]     = useState('');
  const generatedRef               = useRef(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused]   = useState(false);
  const utteranceRef               = useRef(null);

  useEffect(() => () => window.speechSynthesis.cancel(), []);

  useEffect(() => {
    if (!cacheKey) return;
    try {
      const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
      if (cached) {
        const { ts, text } = JSON.parse(cached);
        if (Date.now() - ts < INSIGHT_TTL && text) { setAiText(text); return; }
      }
    } catch {}
    if (autoGenerate && !generatedRef.current) {
      generatedRef.current = true;
      generate();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  const generate = async () => {
    if (!prompt) return;
    setAiLoading(true);
    setAiError('');
    try {
      const text = await callGemini(prompt);
      setAiText(text);
      if (cacheKey)
        localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
    } catch (e) {
      setAiError('Could not generate insight. Check your API key and try again.');
      console.error(e);
    } finally {
      setAiLoading(false);
    }
  };

  const togglePlayback = () => {
    const synth = window.speechSynthesis;
    if (isPlaying) {
      synth.pause(); setIsPlaying(false); setIsPaused(true);
    } else if (isPaused && synth.paused) {
      synth.resume(); setIsPlaying(true); setIsPaused(false);
    } else {
      synth.cancel();
      const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
      utterance.lang    = 'en-IN';
      utterance.onend   = () => { setIsPlaying(false); setIsPaused(false); };
      utterance.onerror = () => { setIsPlaying(false); setIsPaused(false); };
      utteranceRef.current = utterance;
      synth.speak(utterance);
      setIsPlaying(true); setIsPaused(false);
    }
  };

  return (
    <div className="insight-box" style={{ marginTop: 20 }}>
      <div className="insight-header">
        <div className="insight-title">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/>
          </svg>
          {title}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {((aiError && !aiLoading) || (!aiText && !aiLoading && !aiError && !autoGenerate)) && (
            <button className="play-btn" onClick={generate} disabled={aiLoading}
              style={{ background: '#f0ebff', color: '#6B4FA0' }}>
              {aiLoading ? 'Generating...' : '↻ Retry'}
            </button>
          )}
          {aiText && !aiLoading && (
            <button className="play-btn" onClick={togglePlayback}>
              <svg viewBox="0 0 24 24" width="12" height="12">
                {isPlaying
                  ? <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                  : <path d="M8 5v14l11-7z" />}
              </svg>
              {isPlaying ? 'Pause' : 'Play'}
            </button>
          )}
        </div>
      </div>
      {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight…</div>}
      {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
      {aiText && !aiLoading && <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>}
      {!aiText && !aiLoading && !aiError && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>
          AI insight will appear here shortly.
          <button onClick={generate} style={{ marginLeft: 8, background: 'none', border: 'none', color: '#6B4FA0', cursor: 'pointer', textDecoration: 'underline' }}>
            Retry now
          </button>
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────
const TechnicalSEOPage = ({ brandName, websiteUrl, onContinue }) => {
  const [loading, setLoading]             = useState(true);
  const [data, setData]                   = useState(null);
  const [paramInsights, setParamInsights] = useState({});
  const [overallPrompt, setOverallPrompt] = useState('');

  const domain = cleanDomain(websiteUrl);

// ── Replace everything from "const cacheTechnicalSEO" down to 
//    the closing of useEffect in TechnicalSEOPage ──

const POLL_INTERVAL = 2000;
const POLL_TIMEOUT  = 60000;

const cacheTechnicalSEO = (domain, techData) => {
  // techData here is the FINAL resolved data, not the axios response
  try {
    const cacheKey = `technicalSEO_${cleanDomain(domain)}`;
    if (!techData || typeof techData !== 'object') return;

    const summary = techData.summary_card || {};
    const metrics = techData.metrics      || {};

    const mapped = {
      pages_indexed: summary.pages_indexed?.value ?? 0,
      schema_count:  summary.schema_markup?.count ?? 0,
      broken_links:  summary.broken_links?.count  ?? 0,
      alt_coverage:  summary.image_alt_coverage?.coverage ?? 0,
      ssl_status: {
        status:  summary.https_ssl?.status === 'Secure' ? 'Secure'
               : summary.https_ssl?.status === 'Expiring Soon' ? 'Expiring Soon'
               : 'Unknown',
        details: summary.https_ssl?.expires_in_days
               ? `Certificate expires in ${summary.https_ssl.expires_in_days} days` : '',
      },
      robots_txt: {
        status:  metrics.robots_txt?.status === 'present' ? 'Present' : 'Missing',
        url:     `https://${cleanDomain(domain)}/robots.txt`,
        details: metrics.robots_txt?.analysis?.sitemap_references?.length
               ? 'Sitemap referenced' : '',
      },
      sitemap: {
        status:  summary.sitemap?.status === 'Present' ? 'Present' : 'Missing',
        url:     `https://${cleanDomain(domain)}/sitemap.xml`,
        details: summary.sitemap?.url_count ? `${summary.sitemap.url_count} URLs` : '',
      },
      google_analytics:   { detected: metrics.google_analytics?.detected   ?? false, id: metrics.google_analytics?.measurement_id  || '' },
      google_tag_manager: { detected: metrics.google_tag_manager?.detected  ?? false, id: metrics.google_tag_manager?.container_id  || '' },
      meta_pixel:         { detected: metrics.meta_pixel?.detected          ?? false },
      mobile_usability:   { status: summary.mobile_usability?.status === 'Pass' ? 'Pass' : 'Issues Found', details: '' },
      core_web_vitals:    { status: summary.core_web_vitals?.status  === 'Pass' ? 'Pass' : 'Fail', details: '' },
      schema_markup_types: {
        found:   summary.schema_markup?.types   || [],
        missing: summary.schema_markup?.missing || [],
        count:   summary.schema_markup?.count   ?? 0,
      },
      meta_title_issues:  { count: summary.meta_title_issues?.count ?? 0, details: summary.meta_title_issues?.display || '' },
      canonical_tags:     { status: metrics.canonical_issues?.status === 'good' ? 'Present' : 'Needs Improvement', details: '' },
      broken_links_details: { count: summary.broken_links?.count ?? 0, internal: 0, external: 0 },
      insight: techData.ai_insight?.insight || '',
    };

    localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data: mapped }));
    console.log('✅ TechnicalSEO cached for', domain);
    return mapped;
  } catch (e) {
    console.warn('cacheTechnicalSEO failed', e);
    return null;
  }
};

// ── Poll a job until status = completed, then return result ──
const pollJob = (jobId) => new Promise((resolve, reject) => {
  const start   = Date.now();
  const timer   = setInterval(async () => {
    try {
      const res    = await auditAPI.getJob(jobId);   // GET /api/job/{jobId}
      const body   = res?.data || {};
      const status = body.status;

      console.log(`⏳ Job ${jobId} status: ${status}`);

      if (status === 'completed') {
        clearInterval(timer);
        // result lives at body.result or body.data
        resolve(body.result ?? body.data ?? body);
      } else if (status === 'failed' || status === 'error') {
        clearInterval(timer);
        reject(new Error(`Job ${jobId} failed`));
      } else if (Date.now() - start > POLL_TIMEOUT) {
        clearInterval(timer);
        reject(new Error(`Job ${jobId} timed out`));
      }
    } catch (err) {
      clearInterval(timer);
      reject(err);
    }
  }, POLL_INTERVAL);
});


// ── Main useEffect ────────────────────────────────────────────────────────
// useEffect(() => {
//   let cancelled = false;

//   const run = async () => {
//     // 1. Cache hit — use immediately
//     const cached = getTechData(domain);
//     if (cached) {
//       console.log(`⚡ TechnicalSEO cache hit: ${domain}`);
//       if (!cancelled) {
//         setData(cached);
//         setLoading(false);
//         generateAllParameterInsights(cached);
//       }
//       return;
//     }

//     // 2. Cache miss — call API, get job ID, poll until done
//     console.log(`🔄 TechnicalSEO fetching: ${domain}`);
//     try {
//       const initRes = await auditAPI.technicalseo({ domain });
//       const jobId   = initRes?.data?.job_id ?? initRes?.data?.id ?? initRes?.job_id;

//       if (!jobId) {
//         // Some backends return the result directly (no job pattern)
//         const directData = initRes?.data?.data || initRes?.data;
//         if (directData?.summary_card) {
//           const mapped = cacheTechnicalSEO(domain, directData);
//           if (!cancelled && mapped) {
//             setData(mapped);
//             setLoading(false);
//             generateAllParameterInsights(mapped);
//           }
//           return;
//         }
//         throw new Error('No job_id and no direct result in response');
//       }

//       // 3. Poll the job
//       const result = await pollJob(jobId);
//       console.log('✅ Job completed, result keys:', Object.keys(result || {}));

//       if (cancelled) return;

//       // result should now have summary_card + metrics
//       const finalData = result?.summary_card ? result         // result IS the data
//                       : result?.data?.summary_card ? result.data  // nested under .data
//                       : result;                                    // best effort

//       const mapped = cacheTechnicalSEO(domain, finalData);
//       if (mapped) {
//         setData(mapped);
//         setLoading(false);
//         generateAllParameterInsights(mapped);
//       } else {
//         setLoading(false); // show "no data" state
//       }

//     } catch (err) {
//       console.error('❌ TechnicalSEO fetch/poll failed:', err);
//       if (!cancelled) setLoading(false);
//     }
//   };

//   run();

//   // Hard timeout fallback
//   const fallback = setTimeout(() => {
//     if (!cancelled) setLoading(false);
//   }, POLL_TIMEOUT + 5000);

//   return () => {
//     cancelled = true;
//     clearTimeout(fallback);
//   };
// // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [domain]);

useEffect(() => {
  let cancelled = false;

  const run = async () => {
    // 1. Cache hit — use immediately
    const cached = getTechData(domain);
    if (cached) {
      console.log(`⚡ TechnicalSEO cache hit: ${domain}`);
      if (!cancelled) {
        setData(cached);          // ← data first
        setLoading(false);        // ← then hide spinner
        generateAllParameterInsights(cached);
      }
      return;
    }

    // 2. Cache miss — start job
    console.log(`🔄 TechnicalSEO fetching: ${domain}`);
    try {
      const initRes = await auditAPI.technicalseo({ domain });
      const jobId   = initRes?.data?.job_id ?? initRes?.data?.id ?? initRes?.job_id;

      if (!jobId) {
        // Direct response (no job pattern)
        const directData = initRes?.data?.data || initRes?.data;
        if (directData?.summary_card) {
          const mapped = cacheTechnicalSEO(domain, directData);
          if (!cancelled && mapped) {
            setData(mapped);        // ← data first
            setLoading(false);      // ← then hide spinner
            generateAllParameterInsights(mapped);
          }
          return;
        }
        throw new Error('No job_id and no direct result');
      }

      // 3. Poll until complete
      const result = await pollJob(jobId);
      if (cancelled) return;

      const finalData =
        result?.summary_card        ? result       :
        result?.data?.summary_card  ? result.data  :
        result;

      const mapped = cacheTechnicalSEO(domain, finalData);

      if (!cancelled) {
        if (mapped) {
          setData(mapped);          // ← data first
          setLoading(false);        // ← then hide spinner
          generateAllParameterInsights(mapped);
        } else {
          setLoading(false);        // no data state
        }
      }

    } catch (err) {
      console.error('❌ TechnicalSEO fetch/poll failed:', err);
      if (!cancelled) setLoading(false);
    }
  };

  run();

  const fallback = setTimeout(() => {
    if (!cancelled) setLoading(false);
  }, POLL_TIMEOUT + 5000);

  return () => {
    cancelled = true;
    clearTimeout(fallback);
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [domain]);

  // ── FIX: safe accessors — every nested read uses optional chaining ──────
  const generateAllParameterInsights = async (techData) => {
    const brand = brandName || 'Your Brand';

    const sslStatus     = techData.ssl_status?.status === 'Secure' ? 'Secure' : 'Not Secure';
    const robotsStatus  = techData.robots_txt?.status === 'Present'
      ? 'Found and correctly configured'
      : (techData.robots_txt?.status === 'Missing' ? 'Missing' : 'Blocking critical pages');
    const sitemapStatus = techData.sitemap?.status === 'Present'
      ? (techData.sitemap?.submitted ? 'Present and submitted to GSC' : 'Present but not submitted')
      : 'Missing';
    const llmStatus       = 'Missing';
    const gaStatus        = techData.google_analytics?.detected ? 'Active and verified' : 'Not installed';
    const gtmStatus       = techData.google_tag_manager?.detected ? 'Present' : 'Not found';
    const metaPixelStatus = techData.meta_pixel?.detected ? 'Active' : 'Not installed';
    const mobileStatus    = techData.mobile_usability?.status === 'Pass' ? 'Pass' : 'Fail';
    const mobileIssues    = techData.mobile_usability?.details || 'none detected';
    const cwvStatus       = techData.core_web_vitals?.status === 'Pass' ? 'Pass'
      : (techData.core_web_vitals?.status === 'Needs Improvement' ? 'Needs Improvement' : 'Fail');
    const failingMetrics  = techData.core_web_vitals?.details
      || (cwvStatus !== 'Pass' ? 'LCP, CLS, INP' : 'all metrics passing');

    // FIX: safe array join — guard against null/non-array .found
    const schemaFound = Array.isArray(techData.schema_markup_types?.found)
      ? techData.schema_markup_types.found
      : [];
    const schemaTypes = schemaFound.join(', ') || 'none detected';
    const schemaCount = techData.schema_markup_types?.count ?? 0;

    const metaTitleIssues  = (techData.meta_title_issues?.count ?? 0) > 0
      ? `${techData.meta_title_issues.count} issues identified`
      : 'No issues detected';
    const metaTitleDetails = techData.meta_title_issues?.details || '';
    const altCoverage      = techData.alt_coverage ?? 0;
    const canonicalStatus  = techData.canonical_tags?.status === 'Present'
      ? 'Correctly implemented'
      : (techData.canonical_tags?.status === 'Needs Improvement' ? 'Issues identified' : 'Not implemented');
    const canonicalDetails = techData.canonical_tags?.details || '';

    // FIX: safe broken_links_details access
    const brokenTotal    = techData.broken_links_details?.count    ?? 0;
    const brokenInternal = techData.broken_links_details?.internal ?? 0;
    const brokenExternal = techData.broken_links_details?.external ?? 0;

    const combinedPrompt = `You are a senior technical SEO strategist. For each parameter below, generate exactly ONE professional sentence (max 20 words) that assesses the status and its business impact. Use the provided status/details. No jargon. No bullet points. Separate each answer with "[END]" on a new line. Return exactly the answers in the same order.

1. HTTPS / SSL
Brand: ${brand}
HTTPS Status: ${sslStatus}
In one professional sentence, assess the security status of this domain and its implications for customer trust signals and Google's ranking criteria.
[END]

2. robots.txt
Brand: ${brand}
robots.txt: ${robotsStatus}
In one professional sentence, evaluate the robots.txt configuration and its impact on search engine crawl efficiency for this domain.
[END]

3. sitemap.xml
Brand: ${brand}
sitemap.xml: ${sitemapStatus}
In one professional sentence, assess the sitemap status and its direct effect on Google's ability to discover and index this website's content.
[END]

4. llm.txt
Brand: ${brand}
llm.txt: ${llmStatus}
In one professional sentence, evaluate the presence or absence of llm.txt and explain its emerging significance for brand visibility within AI-powered search environments.
[END]

5. Google Analytics GA4
Brand: ${brand}
GA4 Status: ${gaStatus}
In one professional sentence, assess the GA4 implementation status and its impact on the brand's ability to make data-informed marketing decisions.
[END]

6. Google Tag Manager
Brand: ${brand}
GTM Status: ${gtmStatus}
In one professional sentence, evaluate the GTM implementation and its role in enabling efficient marketing tag management and campaign tracking.
[END]

7. Meta Pixel
Brand: ${brand}
Meta Pixel: ${metaPixelStatus}
In one professional sentence, assess the Meta Pixel status and its direct impact on paid social campaign attribution, retargeting capability, and ROI.
[END]

8. Mobile Usability
Brand: ${brand}
Mobile Usability: ${mobileStatus}
Issues identified: ${mobileIssues}
In one professional sentence, evaluate mobile usability compliance and its implications for user experience quality and Google's mobile-first indexing.
[END]

9. Core Web Vitals
Brand: ${brand}
Core Web Vitals Status: ${cwvStatus}
Underperforming metrics: ${failingMetrics}
In one professional sentence, assess Core Web Vitals performance and its influence on Google's page experience ranking signals and search visibility.
[END]

10. Schema Markup
Brand: ${brand}
Schema Types Detected: ${schemaTypes}
Total types implemented: ${schemaCount}
In one professional sentence, evaluate the structured data implementation and its effect on search result appearance, rich snippet eligibility, and click-through rates.
[END]

11. Meta Title Issues
Brand: ${brand}
Meta Title Status: ${metaTitleIssues}
Issue types: ${metaTitleDetails || 'Over character limit / Duplicate titles / Missing'}
In one professional sentence, assess meta title quality and its measurable impact on organic search click-through performance.
[END]

12. Image Alt Coverage
Brand: ${brand}
Alt Text Coverage: ${altCoverage}% of images carry alt text
In one professional sentence, evaluate image alt text coverage and its dual impact on Google Image Search ranking and web accessibility compliance.
[END]

13. Canonical Tags
Brand: ${brand}
Canonical Implementation: ${canonicalStatus}
In one professional sentence, assess canonical tag implementation and its effectiveness in preventing duplicate content from fragmenting search authority.
[END]

14. Broken Links
Brand: ${brand}
Broken Links Detected: ${brokenTotal} (${brokenInternal} internal | ${brokenExternal} external)
In one professional sentence, evaluate the broken link profile and its combined impact on user experience and search engine crawl budget.
[END]`;

    if (!GEMINI_API_KEY) return;

    try {
      const response = await callGemini(combinedPrompt);
      const parts = response.split('[END]').map(p => p.trim()).filter(Boolean);
      const paramKeys = [
        'https', 'robots', 'sitemap', 'llm', 'ga4', 'gtm', 'meta_pixel',
        'mobile_usability', 'cwv', 'schema', 'meta_title', 'alt_coverage',
        'canonical', 'broken_links',
      ];
      const insightsMap = {};
      for (let i = 0; i < paramKeys.length && i < parts.length; i++)
        insightsMap[paramKeys[i]] = parts[i];
      setParamInsights(insightsMap);
    } catch (err) {
      console.error('Failed to generate per-parameter insights', err);
    }
  };

  // ── Overall prompt — safe accessors throughout ───────────────────────────
  useEffect(() => {
    if (!data) return;
    const brand = brandName || 'Your Brand';

    const passCount = [
      data.ssl_status?.status === 'Secure',
      data.robots_txt?.status === 'Present',
      data.sitemap?.status === 'Present',
      data.google_analytics?.detected,
      data.google_tag_manager?.detected,
      data.meta_pixel?.detected,
      data.mobile_usability?.status === 'Pass',
      data.core_web_vitals?.status === 'Pass',
      (data.schema_markup_types?.count ?? 0) > 0,
      (data.meta_title_issues?.count ?? 0) === 0,
      (data.alt_coverage ?? 0) >= 70,
      data.canonical_tags?.status === 'Present',
      (data.broken_links ?? 0) === 0,
    ].filter(Boolean).length;

    const criticalItems = [];
    if (data.ssl_status?.status !== 'Secure')          criticalItems.push('HTTPS not secure');
    if (!data.google_analytics?.detected)              criticalItems.push('GA4 missing');
    if (!data.meta_pixel?.detected)                    criticalItems.push('Meta Pixel missing');
    if ((data.meta_title_issues?.count ?? 0) > 0)     criticalItems.push(`${data.meta_title_issues.count} meta title issues`);
    if ((data.broken_links ?? 0) > 0)                 criticalItems.push(`${data.broken_links} broken links`);

    const warningItems = [];
    if (data.robots_txt?.status !== 'Present')         warningItems.push('robots.txt missing');
    if (data.sitemap?.status !== 'Present')            warningItems.push('sitemap missing');
    if (data.mobile_usability?.status !== 'Pass')      warningItems.push('mobile usability issues');
    if (data.core_web_vitals?.status !== 'Pass')       warningItems.push('Core Web Vitals failing');
    if ((data.schema_markup_types?.count ?? 0) < 3)   warningItems.push('low schema markup');

    setOverallPrompt(
      `You are a senior technical SEO strategist preparing a professional brand audit report. Business-appropriate language. No bullet points. Maximum 3 sentences.

Brand: ${brand}
Checks passed: ${passCount} of 13
Critical failures: ${criticalItems.join(', ') || 'none'}
Warnings requiring attention: ${warningItems.join(', ') || 'none'}
Pages indexed by Google: ${data.pages_indexed ?? 0}
Broken links identified: ${data.broken_links ?? 0}
Image alt text coverage: ${data.alt_coverage ?? 0}%

Deliver a professional summary of this website's technical SEO health. Communicate the cumulative impact of identified issues on search visibility and user experience. Conclude with a clear statement of the highest-priority remediation and its expected business benefit upon resolution.`
    );
  }, [data, brandName]);

  if (loading) {
  return (
    <div className="card" id="card-7">
      <div className="eyebrow">Technical SEO</div>
      <h2 className="ctitle">Website Technical Audit</h2>
      <p className="cdesc">A deep technical check of your website — what's working, what's broken, and what needs attention.</p>
      <div className="tseo-fetch show">
        <div className="spinner" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span>Running technical audit on your website…</span>
          <span style={{ fontSize: 12, color: '#888' }}>
            Checking SSL, sitemap, schema, Core Web Vitals and more — takes 30–60 seconds
          </span>
        </div>
      </div>
    </div>
  );
}

  if (!data) {
    return (
      <div className="card" id="card-7">
        <div className="eyebrow">Technical SEO</div>
        <h2 className="ctitle">Website Technical Audit</h2>
        <p className="cdesc">No technical data available. Please try refreshing.</p>
      </div>
    );
  }

  // ── FIX: build paramList with full optional chaining on every nested access ──
  const ssl     = data.ssl_status       || {};
  const robots  = data.robots_txt       || {};
  const sitemap = data.sitemap          || {};
  const ga      = data.google_analytics || {};
  const gtm     = data.google_tag_manager || {};
  const pixel   = data.meta_pixel       || {};
  const mobile  = data.mobile_usability || {};
  const cwv     = data.core_web_vitals  || {};
  const schema  = data.schema_markup_types || {};
  const metaT   = data.meta_title_issues  || {};
  const canon   = data.canonical_tags     || {};
  const broken  = data.broken_links_details || {};

  const schemaFound   = Array.isArray(schema.found)   ? schema.found   : [];
  const schemaMissing = Array.isArray(schema.missing)  ? schema.missing : [];

  const paramList = [
    {
      key: 'https', name: 'HTTPS / SSL', desc: 'Secure connection status',
      status: ssl.status || 'Unknown', badge: ssl.status || 'Unknown',
      insightDefault: ssl.details || '',
    },
    {
      key: 'robots', name: 'robots.txt', desc: 'Search engine crawl instructions',
      status: robots.status || 'Unknown', badge: robots.status || 'Unknown',
      insightDefault: [robots.url, robots.details].filter(Boolean).join(' — '),
    },
    {
      key: 'sitemap', name: 'sitemap.xml', desc: 'Page discovery map for search engines',
      status: sitemap.status || 'Unknown', badge: sitemap.status || 'Unknown',
      insightDefault: [sitemap.url, sitemap.details].filter(Boolean).join(' — '),
    },
    {
      key: 'ga4', name: 'Google Analytics GA4', desc: 'Website traffic tracking',
      status: ga.detected ? 'Detected' : 'Not Detected',
      badge:  ga.detected ? 'Active'   : 'Missing',
      insightDefault: ga.detected ? `Measurement ID: ${ga.id || '—'}` : 'GA4 not found – install gtag.js',
    },
    {
      key: 'gtm', name: 'Google Tag Manager', desc: 'Tag and tracking management',
      status: gtm.detected ? 'Detected' : 'Not Detected',
      badge:  gtm.detected ? 'Active'   : 'Missing',
      insightDefault: gtm.detected ? `Container ID: ${gtm.id || '—'}` : 'GTM not found – install container snippet',
    },
    {
      key: 'meta_pixel', name: 'Meta Pixel', desc: 'Facebook/Instagram ad tracking',
      status: pixel.detected ? 'Detected' : 'Not Detected',
      badge:  pixel.detected ? 'Active'   : 'Missing',
      insightDefault: pixel.detected ? 'Meta Pixel installed' : `Not installed – can't retarget ads`,
      critical: !pixel.detected,
    },
    {
      key: 'mobile_usability', name: 'Mobile Usability', desc: 'Google mobile-friendliness check',
      status: mobile.status || 'Unknown', badge: mobile.status || 'Unknown',
      insightDefault: mobile.details || '',
    },
    {
      key: 'cwv', name: 'Core Web Vitals', desc: 'Google page experience signals',
      status: cwv.status || 'Unknown', badge: cwv.status || 'Unknown',
      insightDefault: cwv.details || '',
      critical: cwv.status !== 'Pass',
    },
    {
      key: 'schema', name: 'Schema Markup', desc: 'Structured data for rich search results',
      status: `${schema.count ?? 0} types`, badge: `${schema.count ?? 0} found`,
      insightDefault: `Found: ${schemaFound.join(', ') || 'None'} · Missing: ${schemaMissing.join(', ') || 'None'}`,
    },
    {
      key: 'meta_title', name: 'Meta Title Issues', desc: 'Page title length and duplication check',
      status: `${metaT.count ?? 0} issues`, badge: `${metaT.count ?? 0} issues`,
      insightDefault: metaT.details || '',
      critical: (metaT.count ?? 0) > 0,
    },
    {
      key: 'alt_coverage', name: 'Image Alt Coverage', desc: 'Accessibility and image SEO',
      status: `${data.alt_coverage ?? 0}%`, badge: `${data.alt_coverage ?? 0}% covered`,
      insightDefault: `${100 - (data.alt_coverage ?? 0)}% of images missing alt text`,
    },
    {
      key: 'canonical', name: 'Canonical Tags', desc: 'Duplicate content prevention',
      status: canon.status || 'Unknown', badge: canon.status || 'Unknown',
      insightDefault: canon.details || '',
    },
    {
      key: 'broken_links', name: 'Broken Links', desc: 'Internal and external link health',
      status: `${broken.count ?? 0} found`, badge: `${broken.count ?? 0} found`,
      insightDefault: `Internal: ${broken.internal ?? 0}, External: ${broken.external ?? 0}`,
      critical: (broken.count ?? 0) > 0,
    },
  ];

  return (
    <div className="card" id="card-7">
      <div className="eyebrow">Technical SEO</div>
      <h2 className="ctitle">Website Technical Audit</h2>
      <p className="cdesc">A deep technical check of your website — what's working, what's broken, and what needs attention.</p>

      <div className="tseo-wrap show">
        <div className="tseo-section">Key Metrics</div>
        <div className="tseo-stats">
          <div className="tstat">
            <div className="tstat-top">
              <span className="tstat-label">Pages Indexed</span>
              <span className={`tstat-badge ${(data.pages_indexed ?? 0) > 0 ? 'badge-pass' : 'badge-fail'}`}>
                {(data.pages_indexed ?? 0) > 0 ? 'Good' : 'Low'}
              </span>
            </div>
            <div className="tstat-val">{data.pages_indexed ?? 0}</div>
            <div className="tstat-sub">via Google Search Console</div>
          </div>
          <div className="tstat">
            <div className="tstat-top">
              <span className="tstat-label">Schema Types</span>
              <span className={`tstat-badge ${(data.schema_count ?? 0) >= 5 ? 'badge-pass' : (data.schema_count ?? 0) >= 2 ? 'badge-warn' : 'badge-fail'}`}>
                {(data.schema_count ?? 0) >= 5 ? 'Good' : (data.schema_count ?? 0) >= 2 ? 'Partial' : 'Low'}
              </span>
            </div>
            <div className="tstat-val">{data.schema_count ?? 0}</div>
            <div className="tstat-sub">of 7 recommended</div>
          </div>
          <div className="tstat">
            <div className="tstat-top">
              <span className="tstat-label">Broken Links</span>
              <span className={`tstat-badge ${(data.broken_links ?? 0) === 0 ? 'badge-pass' : (data.broken_links ?? 0) <= 5 ? 'badge-warn' : 'badge-fail'}`}>
                {(data.broken_links ?? 0) === 0 ? 'Clean' : (data.broken_links ?? 0) <= 5 ? 'Fix Soon' : 'Critical'}
              </span>
            </div>
            <div className="tstat-val">{data.broken_links ?? 0}</div>
            <div className="tstat-sub">found on website</div>
          </div>
          <div className="tstat">
            <div className="tstat-top">
              <span className="tstat-label">Alt Text Coverage</span>
              <span className={`tstat-badge ${(data.alt_coverage ?? 0) >= 80 ? 'badge-pass' : (data.alt_coverage ?? 0) >= 50 ? 'badge-warn' : 'badge-fail'}`}>
                {(data.alt_coverage ?? 0) >= 80 ? 'Good' : (data.alt_coverage ?? 0) >= 50 ? 'Partial' : 'Poor'}
              </span>
            </div>
            <div className="tstat-val">{data.alt_coverage ?? 0}%</div>
            <div className="tstat-sub">images with alt text</div>
          </div>
        </div>

        <div className="tseo-section">Technical Checks</div>
        <div className="tseo-checks">
          {paramList.map((check, idx) => {
            const isBad  = check.status === 'Missing' || check.status === 'Not Detected'
                        || check.status === 'Issues Found' || check.status === 'Fail'
                        || check.critical;
            const isWarn = !isBad && (check.status === 'Expiring Soon'
                        || check.status === 'Partial Pass'
                        || check.status === 'Needs Improvement');
            const badgeClass = isBad ? 'badge-fail' : isWarn ? 'badge-warn' : 'badge-pass';
            const iconClass  = isBad ? 'icon-fail'  : isWarn ? 'icon-warn'  : 'icon-pass';
            const icon       = isBad ? '❌' : isWarn ? '⚠️' : '✅';
            const insClass   = isBad ? 'ins-fail' : isWarn ? 'ins-warn' : 'ins-pass';
            const aiInsight  = paramInsights[check.key] || check.insightDefault;

            return (
              <div key={idx} className={`tcheck-row ${isBad ? 'critical' : ''}`}>
                <div className="tcheck-top">
                  <div className={`tcheck-icon ${iconClass}`}>{icon}</div>
                  <div className="tcheck-info">
                    <div className="tcheck-name">{check.name}</div>
                    <div className="tcheck-desc">{check.desc}</div>
                  </div>
                  <span className={`tcheck-badge ${badgeClass}`}>{check.badge}</span>
                </div>
                <div className={`tcheck-insight ${insClass}`}>
                  <svg viewBox="0 0 24 24" width="13" height="13">
                    {isBad
                      ? <path fill="#C0392B" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                      : isWarn
                        ? <path fill="#C47D1A" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                        : <path fill="#0D9488" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>}
                  </svg>
                  <span>{aiInsight}</span>
                </div>
              </div>
            );
          })}
        </div>

        <AIInsightBox
          title="Technical SEO Overall Insight"
          cacheKey={`tech_overall_${domain}`}
          prompt={overallPrompt}
          autoGenerate={!!GEMINI_API_KEY}
        />
      </div>

      <button className="btn" onClick={onContinue} style={{ marginTop: 20 }}>
        Explore Local Visibility
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
        </svg>
      </button>
    </div>
  );
};

export default TechnicalSEOPage;
